<div class="phx-overview-item-label-subtext-container">
  <span class="phx-overview-item-label" phx-tooltip [phxContent]="phxLabelTooltipContent">{{ phxLabel }}</span>
  <ng-container *ngIf="isMobileView" [ngTemplateOutlet]="subtextTemplate"></ng-container>
</div>
<div class="phx-overview-item-kpi-container">
  <span class="phx-overview-item-kpi">{{ formatValue(phxValue) }}</span>
  <ng-container *ngIf="changeType !== 'no-change'">
    <div class="phx-overview-item-change-wrapper" [ngClass]="getChangeContainerClass()">
      <span class="phx-overview-item-change">
        {{ changeValue > 0 ? '↑' : '↓' }} {{ phxShowPercentageChange ? percentageChangeValue : absoluteChangeValue }}
      </span>
    </div>
  </ng-container>
</div>
<ng-container *ngIf="!isMobileView" [ngTemplateOutlet]="subtextTemplate"></ng-container>

<ng-template #subtextTemplate>
  <span *ngIf="phxSubtext" class="phx-overview-item-subtext">{{ phxSubtext }}</span>
</ng-template>
